/* <article-share>: copy link (with a "Link copied" tip) and the native share sheet where supported. */
if (!customElements.get('article-share')) {
  customElements.define('article-share', class ArticleShare extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.status = this.querySelector('.article-share__status');
      const native = this.querySelector('[data-share-native]');
      if (native && navigator.share) {
        native.hidden = false;
        native.addEventListener('click', () => navigator.share({ title: native.dataset.title || document.title, url: location.href }).catch(() => {}));
      }
      this.querySelector('[data-share-copy]')?.addEventListener('click', async e => {
        const btn = e.currentTarget;
        let ok = false;
        try { await navigator.clipboard.writeText(btn.dataset.url || location.href); ok = true; } catch { /* clipboard blocked: ok stays false */ }
        const msg = ok ? this.dataset.copied : this.dataset.copyFailed;
        btn.dataset.tip = msg;
        btn.classList.add('is-tipped');
        if (this.status) this.status.textContent = msg;
        clearTimeout(this.t);
        this.t = setTimeout(() => btn.classList.remove('is-tipped'), 1600);
      });
    }
  });
}
